import { Dialog, Button, DialogContent, DialogActions, DialogContentText, IconButton} from "@mui/material"
import { Delete } from "@mui/icons-material"
import { useState } from "react"
import { Form, useNotify, useRecordContext, useRefresh, useTranslate } from "react-admin"
import { apiService } from "../../apiService"
import { DraftReadModel, InvoiceReadModel, RemoveCommentForDraftCommand, RemoveCommentForInvoiceCommand, RemoveCommentForInvoiceReminderCommand, RemoveCommentForReverseInvoiceCommand } from "../../GeneratedClients/FreeBillApi"

interface IProps {
  index: number,
  resource: "invoices" | "drafts" | "reverseInvoices" | "invoiceReminders"
}

const RemoveCommentForInvoice = ({index, resource}: IProps) => {

  const record: InvoiceReadModel | DraftReadModel = useRecordContext()
  const notify = useNotify()
  const refresh = useRefresh()
  const [open, setOpen] = useState<boolean>(false)
  const translate = useTranslate()

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSubmit = async() => {
    try {
      switch (resource) {
        case "invoices":
          var removeCommentForInvoiceCommand: RemoveCommentForInvoiceCommand = {
            userId: record.userId,
            invoiceId: record.id,
            index: index
          }
          await apiService.InvoicesApi.removeCommentForInvoice({removeCommentForInvoiceCommand: removeCommentForInvoiceCommand, invoiceId: record.id!})      
          break;
        case "drafts":
          var removeCommentForDraftCommand: RemoveCommentForDraftCommand = {
            userId: record.userId,
            draftId: record.id,
            index: index
          }
          await apiService.DraftsApi.removeCommentForDraft({removeCommentForDraftCommand: removeCommentForDraftCommand, draftId: record.id!})
          break;
        case "reverseInvoices":
          var removeCommentForReverseInvoiceCommand: RemoveCommentForReverseInvoiceCommand = {
            userId: record.userId,
            reverseInvoiceId: record.id,
            index: index
          }
          await apiService.ReverseInvoicesApi.removeCommentForReverseInvoice({removeCommentForReverseInvoiceCommand: removeCommentForReverseInvoiceCommand, reverseInvoiceId: record.id!})
          break;
          case "invoiceReminders":
            var removeCommentForInvoiceReminderCommand: RemoveCommentForInvoiceReminderCommand = {
              userId: record.userId,
              invoiceReminderId: record.id,
              index: index
            }
            await apiService.InvoiceRemindersApi.removeCommentForInvoiceReminder({removeCommentForInvoiceReminderCommand: removeCommentForInvoiceReminderCommand, invoiceReminderId: record.id!})
            break;
          default:
          break;
      }
      
      handleClose()
      notify(translate("resources.invoices.notifications.commentRemoved"))
      refresh()
    } catch (error) {
      notify(`${error}`, {type: "error"})
    }
  }

  if(!record) return null

  return (
    <>
      <IconButton
        onClick={handleOpen}
        color="error"
      >
        <Delete fontSize="small" />
      </IconButton>
      <Dialog 
        open={open} 
        onClose={handleClose}
      >
        <Form onSubmit={handleSubmit}>
          <DialogContent>
            <DialogContentText>
              {translate("resources.invoices.dialogs.removeComment")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} >{translate('ra.action.cancel')}</Button>
            <Button color="error" type="submit">{translate('resources.invoices.actions.removeComment')}</Button>
          </DialogActions>
        </Form>
      </Dialog>
    </>    
  )
}

export default RemoveCommentForInvoice